import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateSetting, updateRefundSettingsDetails } from "../../redux/slices";
import {
  storeSettingTypes,
  refundSettingsActionTypes,
} from "../../redux/utils";
import browserLang from "browser-lang";
export const MultiLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [languageLabel, setLanguageLabel] = useState("Language");
  const dispatch = useDispatch();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  useEffect(() => {
    const detectedLanguage = browserLang();
    setSelectedLanguage(detectedLanguage);
  }, []);

  useEffect(() => {
    switch (selectedLanguage) {
      case "da":
        setLanguageLabel("Sprog");
        dispatch(
          updateSetting({
            key: storeSettingTypes.UPDATE_THEME_CONFIG,
            value: storeConfigState.themeConfigDa,
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
            value: storeConfigState?.themeConfigDa
              ?.return_submission_original_payment_left_content
              ? storeConfigState?.themeConfigDa
                  ?.return_submission_original_payment_left_content
              : `${storeConfigState?.themeConfigDa?.your_return_request} ${otherSettingsState.ran} ${storeConfigState?.themeConfigDa?.has_been_submitted_original_payment_method}`,
          })
        );

        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
            value:
              storeConfigState?.themeConfigDa
                ?.return_submission_original_payment_left_title,
          })
        );
        break;
      case "de":
        setLanguageLabel("Sprache");
        dispatch(
          updateSetting({
            key: storeSettingTypes.UPDATE_THEME_CONFIG,
            value: storeConfigState.themeConfigDe,
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
            value: storeConfigState?.themeConfigDe
              ?.return_submission_original_payment_left_content
              ? storeConfigState?.themeConfigDe
                  ?.return_submission_original_payment_left_content
              : `${storeConfigState?.themeConfigDe?.your_return_request} ${otherSettingsState.ran} ${storeConfigState?.themeConfigDe?.has_been_submitted_original_payment_method}`,
          })
        );

        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
            value:
              storeConfigState?.themeConfigDe
                ?.return_submission_original_payment_left_title,
          })
        );
        break;
      case "en":
        setLanguageLabel("Language");
        dispatch(
          updateSetting({
            key: storeSettingTypes.UPDATE_THEME_CONFIG,
            value: storeConfigState.themeConfigEn,
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
            value: storeConfigState?.themeConfigEn
              ?.return_submission_original_payment_left_content
              ? storeConfigState?.themeConfigEn
                  ?.return_submission_original_payment_left_content
              : `${storeConfigState?.themeConfigEn?.your_return_request} ${otherSettingsState.ran} ${storeConfigState?.themeConfigEn?.has_been_submitted_original_payment_method}`,
          })
        );

        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
            value:
              storeConfigState?.themeConfigEn
                ?.return_submission_original_payment_left_title,
          })
        );
        break;
      case "es":
        setLanguageLabel("Idioma");
        dispatch(
          updateSetting({
            key: storeSettingTypes.UPDATE_THEME_CONFIG,
            value: storeConfigState.themeConfigEs,
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
            value: storeConfigState?.themeConfigEs
              ?.return_submission_original_payment_left_content
              ? storeConfigState?.themeConfigEs
                  ?.return_submission_original_payment_left_content
              : `${storeConfigState?.themeConfigEs?.your_return_request} ${otherSettingsState.ran} ${storeConfigState?.themeConfigEs?.has_been_submitted_original_payment_method}`,
          })
        );

        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
            value:
              storeConfigState?.themeConfigEs
                ?.return_submission_original_payment_left_title,
          })
        );

        break;
      default:
        return null;
    }
  }, [
    selectedLanguage,
    storeConfigState.themeConfigDa,
    storeConfigState.themeConfigDe,
    storeConfigState.themeConfigEs,
    storeConfigState.themeConfigEn,
  ]);
  return (
    <div className="lang-dropdown-container">
      <label htmlFor="language">{languageLabel} </label>{" "}
      <select
        id="language"
        className="language-dropdown"
        value={selectedLanguage}
        onChange={(e) => setSelectedLanguage(e.target.value)}
      >
        <option value="en">English</option>
        <option value="de">Deutsch</option>
        <option value="da">dansk</option>
        <option value="es">Español</option>
        {/* Add other language options */}
      </select>
    </div>
  );
};
